// extracted by mini-css-extract-plugin
export var screen1__date = "screen1a-module--screen1__date--8a56f";
export var screen1__doItem = "screen1a-module--screen1__do-item--e7e70";
export var screen1__doList = "screen1a-module--screen1__do-list--060f0";
export var screen1__info = "screen1a-module--screen1__info--bd8e1";
export var screen1__innerContainer = "screen1a-module--screen1__inner-container--b2396";
export var screen1__mainInfo = "screen1a-module--screen1__main-info--5aa13";
export var screen1__subtitle = "screen1a-module--screen1__subtitle--fa589";
export var screen1__title = "screen1a-module--screen1__title--85cbf";